module.exports = __webpack_public_path__ + "img/Engie_80X30.f5d03f9f.png";